import React from 'react';
import { useSelector } from 'react-redux';
import { createTheme } from "@fluentui/react";
import { getCurrentTheme } from '../store/selectors/app.selectors';
import { withRouter } from 'react-router-dom';
import { loadTheme } from '@fluentui/react/lib/Styling';
import { ThemeProvider } from '@fluentui/react';
import { CoherenceV9DarkTheme, CoherenceV9LightTheme } from '@coherence-design-system/styles';

const AppTheme: React.FC = props => {
  const currentTheme = useSelector(getCurrentTheme);
  if (localStorage.getItem('theme') == null)
    localStorage.setItem('theme', 'default');
  const renderMain = (): JSX.Element => {
    const selectedTheme = createTheme(currentTheme);
    let themeSemanticcolors = localStorage.getItem('theme') === 'dark' ? CoherenceV9DarkTheme.semanticColors : CoherenceV9LightTheme.semanticColors;
    selectedTheme.semanticColors = { ...themeSemanticcolors, ...selectedTheme.semanticColors };//localStorage.getItem('theme') =='default' ? CoherenceV9LightTheme.semanticColors:CoherenceV9DarkTheme.semanticColors;
    if (localStorage.getItem('theme') == 'dark') {
      selectedTheme.palette.neutralLighter = "#31302f";
      selectedTheme.palette.white = "#323130";
      selectedTheme.palette.neutralLighterAlt = "#eff6fc";
    }
    return (
      <ThemeProvider theme={selectedTheme}>
        {props.children}
      </ThemeProvider>
    );
  }
  return renderMain();

}

export const AppThemeProvider = withRouter(AppTheme);